// Error types (`extensions.type`) of the marketplace API's auth/registration
// operations. The global error link does not show notifications for them; the
// forms render the server message inline instead (see utils/getErrorMessage).
enum AuthException {
  AuthException = 'AuthException',
  AuthInvalidPasswordException = 'AuthInvalidPasswordException',
  AuthUsernameExistsException = 'AuthUsernameExistsException',
  AuthUserNotFoundException = 'AuthUserNotFoundException',
  AuthLoginFailedException = 'AuthLoginFailedException',
  AuthTokenNotFoundException = 'AuthTokenNotFoundException',
  AuthRateLimitExceededException = 'AuthRateLimitExceededException',
}

// Fallback texts, used only when the server sent no message.
export const AuthExceptionMessage = {
  [AuthException.AuthException]: 'Something went wrong. Please try again.',
  [AuthException.AuthInvalidPasswordException]:
    'The password must be at least 10 characters long.',
  [AuthException.AuthUsernameExistsException]: 'The user already exists.',
  [AuthException.AuthUserNotFoundException]: 'The email or password is wrong.',
  [AuthException.AuthLoginFailedException]: 'The email or password is wrong.',
  [AuthException.AuthTokenNotFoundException]:
    'This link is invalid or has expired.',
  [AuthException.AuthRateLimitExceededException]:
    'Too many attempts. Please wait a few minutes and try again.',
};

export default AuthException;
